import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useMemo } from 'react';
import { PART_NUMBER_DESCRIPTIONS } from '../../utils/billing';
import KpiCard from './KpiCard';

// The four-tile KPI row that sits above the deployments table on both
// the team-scoped and company-wide deployment views. Totals are derived
// from the same `deployments` array the table renders so the numbers
// stay in sync with the rows beneath.
DeploymentsKpiRow.propTypes = {
  partNumber: PropTypes.string.isRequired,
  deployments: PropTypes.array
};

DeploymentsKpiRow.defaultProps = {
  deployments: []
};

export default function DeploymentsKpiRow({ partNumber, deployments }) {
  const totalQuantity = useMemo(
    () => deployments.reduce((sum, d) => sum + (d.quantity || 0), 0),
    [deployments]
  );
  const totalBillableQuantity = useMemo(
    () => deployments.reduce((sum, d) => sum + (d.billableQuantity || 0), 0),
    [deployments]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <KpiCard label="Part Number" value={partNumber} emphasized />
      </Grid>
      <Grid item xs={12} sm={4}>
        <KpiCard label="Total Quantity" value={totalQuantity} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <KpiCard label="Total Billable Quantity" value={totalBillableQuantity} />
      </Grid>
      <Grid item xs={12}>
        <KpiCard
          label="Part Number Description"
          value={PART_NUMBER_DESCRIPTIONS[partNumber] || '-'}
          valueVariant="body2"
        />
      </Grid>
    </Grid>
  );
}
